export default {
  s: '%d सेकंड',
  smicro: '%d सेकंड',
  smid: '%d सेकंड',

  ss: '%d सेकंड',
  ssmicro: '%d सेकंड',
  ssmid: '%d सेकंड',

  m: '%d मिनट',
  mmicro: '%d मिन',
  mmid: '%d मिन',

  mm: '%d मिनट',
  mmmicro: '%d मिन',
  mmmid: '%d मिन',

  h: '%d घंटा',
  hmicro: '%d घं',
  hmid: '%d घंटा',

  hh: '%d घंटे',
  hhmicro: '%d घं',
  hhmid: '%d घंटे',

  d: '%d दिन',
  dmicro: '%d दिन',
  dmid: '%d दिन',

  dd: '%d दिन',
  ddmicro: '%d दिन',
  ddmid: '%d दिन',
};
